(function($, window){

    let CarouselFJ = function(carouselEl) {

        let curIndex = 0;
        let slideHolder = carouselEl.find('.slides');
        let slides = carouselEl.find('.slides > li');
        let autoAdvance = carouselEl.data('autoplay');
        let amongContent = carouselEl.closest('#main-content').length;
        const transitionDuration = amongContent ? 0.8 : 1.2;
        let autoAdvanceDelay = 6;
        let navLock = false;
        let dotLinks = [];
        let videos = [];
        const deviceType = window.screen.width < 768 ? 'mobile' : 'desktop';
        let captionArea = $('<div/>').addClass('caption-area');
        let captions;

        let preload = () => {
            slides.remove();

            function loadSlide(i) {
                if (i >= slides.length) {
                    return;
                }

                populateSlide(i);
                let populatedSlide = slides.eq(i);
                
                let tmpImg = new Image();
                tmpImg.src = populatedSlide.data('imgPreloadSrc');

                $(tmpImg).imagesLoaded().done(() => {
                    if (dotLinks[i]) {
                        dotLinks[i].addClass('loaded');
                    }
                    populatedSlide.data('isLoaded', true);
                    loadSlide(i+1);
                });
            }
            
            loadSlide(0);
        };

        let addNavs = () => {
            let dotNav = $('<ul/>').addClass('slide-nav');
            
            if (slides.length > 1) {
                for (let i=0; i<slides.length; i++) {
                    let dotLink = $('<a/>').attr('href', '#').click((e) => {
                        e.preventDefault();
                        autoAdvance = false;
                        this.gotoSlide({slideIndex: i});
                    });
                    dotLinks.push(dotLink);
                    if (i == curIndex) {
                        dotLink.addClass('active');
                    }
                    let dotLi = $('<li/>').append(dotLink);
                    dotNav.append(dotLi);
                }
            }

            if (amongContent && slides.length > 1) {
                let arrowNav = $('<div/>').addClass('arrow-nav');
                arrowNav.append($('<a/>').attr('href', '#').addClass('next').click(e => {e.preventDefault(); moveRight();}));
                arrowNav.append($('<a/>').attr('href', '#').addClass('previous').click(e => {e.preventDefault(); moveLeft();}));

                carouselEl.append(arrowNav);
            }
            else {
                // Still appending dotNav, even if empty, for consistent spacing
                carouselEl.append(dotNav);
            }

            var hammertime = new Hammer(carouselEl[0]);
            hammertime.on('swipeleft', () => {moveRight();});
            hammertime.on('swiperight', () => {moveLeft();});
        };

        let placeCaptions = () => {
            let hasCaptions = false;

            slides.each((i, slideEl) => {
                let el = $(slideEl);
                if (el.find('.caption').length) {
                    hasCaptions = true;
                    let caption = el.find('.caption');
                    captionArea.append(caption);
                }
            });

            if (hasCaptions) {
                captions = captionArea.find('.caption');
                carouselEl.after(captionArea);
            }
        };

        let showCaption = destination => {
            const {slideIndex, force} = destination;

            if (typeof captions == 'undefined') {
                return;
            }

            if (force) {
                captions.hide();
                captions.eq(slideIndex).show();
            }
            else {
                if (curIndex == slideIndex) {
                    return;
                }
                // captionArea.css('min-height', captionArea.height());
                captionArea.css('height', captionArea.height());
                let tl = gsap.timeline();
                tl.to(captions.eq(curIndex), {
                    duration: transitionDuration * 0.5,
                    opacity: 0,
                    ease: 'power2.in',
                    display: 'none'
                }).fromTo(captions.eq(slideIndex), {
                    opacity: 0
                }, {
                    duration: transitionDuration * 0.5,
                    opacity: 1,
                    display: 'block',
                    ease: 'power2.out',
                    onStart: () => {
                        setTimeout(()=>{
                            captionArea.css('height', captions.eq(slideIndex).outerHeight());
                        },30)
                    },
                    onComplete: () => {
                        // captionArea.css('min-height', 0);
                        captionArea.css('height', 'auto');
                    
                    }
                });
            }
        };

        let populateSlide = (i) => {
            let el = slides.eq(i);
            let slideContent;

            switch (el.data('type')) {
                case 'img':
                    el.data('imgPreloadSrc', el.data('src'));
                    slideContent = $('<div/>').addClass('slide').css('background-image', `url('${ el.data('src') }')`);
                    if (el.data('anchor')) {
                        const anchorLookup = {
                            c: 'center',
                            t: 'top',
                            rt: 'right top',
                            r: 'right',
                            rb: 'right bottom',
                            b: 'bottom',
                            lb: 'left bottom',
                            l: 'left',
                            lt: 'left top'
                        }
                        if (anchorLookup.hasOwnProperty(el.data('anchor'))) {
                            slideContent.css('background-position', anchorLookup[el.data('anchor')]); 
                        }
                    }
                    break;

                case 'video':
                    el.data('imgPreloadSrc', el.data('src').poster);
                    slideContent = $('<div/>').addClass('slide');
                    
                    let imgFalllback = setTimeout(() => {
                        slideContent.css('background-image', `url('${ el.data('src').poster }')`);
                    }, 2000);

                    let video = $('<video/>').attr({
                            preload: 'auto',
                            playsinline: ''
                        })
                        .prop('autoplay', true)
                        .prop('loop', true)
                        .prop('muted', true)
                        .addClass('t-vid');

                    video.on('play', function(){
                        clearTimeout(imgFalllback);
                        $(this).css('opacity', 1);
                    });

                    const permittedTypes = ['webm', 'mp4'];

                    for (let src of el.data('src').video[deviceType].src) {
                        let ext = src.split('.').pop();
                        
                        if (permittedTypes.includes(ext)) {
                            let source = $('<source/>').attr({
                                src: src,
                                type: 'video/' + ext
                            });

                            video.append(source);
                        }
                    }
                    
                    slideContent.append(video);
                    videos.push({
                        el: video, 
                        dimensions: el.data('src').video[deviceType].dimensions
                    });
                    break;
            }

            el.append(slideContent);
            
            if (parseInt(el.data('tint')) > 0) {
                const tintFactor = deviceType == 'mobile' ? 2 : 1;
                let tint = $('<div/>').addClass('tint').css('opacity', tintFactor * el.data('tint') / 100);
                el.append(tint);
            }
            el.data('populated', true);
        };

        this.gotoSlide = (destination) => {

            const {slideIndex, force, direction=false} = destination;

            let slideToShow = slides.eq(slideIndex);

            if (navLock || (!destination.force && !slideToShow.data('isLoaded'))) {
                return;
            }
            
            showCaption(destination);

            if (force) {
                slideHolder.empty();
                slideHolder.append(slideToShow);
            }
            else {

                if (slideIndex == curIndex) {
                    return;
                }

                navLock = true;
                let currentSlide = slides.eq(curIndex);
                
                // Determine direction
                let transitionDirection = direction;
                if (!transitionDirection) {
                    transitionDirection = slideIndex > curIndex ? 'forwards' : 'backwards';
                }

                // Move slides        
                slideToShow.removeClass('pos-' + (transitionDirection == 'forwards' ? 'left' : 'right'));
                slideToShow.addClass('pos-' + (transitionDirection == 'forwards' ? 'right' : 'left'));
                slideHolder.append(slideToShow);

                let possibleVideo = slideToShow.find('video');
                if (possibleVideo.length) {possibleVideo[0].play();}
                
                setTimeout(() => {
                    slideToShow.removeClass('pos-' + (transitionDirection == 'forwards' ? 'right' : 'left'));
                    currentSlide.addClass('pos-' + (transitionDirection == 'forwards' ? 'left' : 'right'));
                }, 30);
                        
                // Clean up slides
                setTimeout(() => {
                    currentSlide.detach();
                    curIndex = slideIndex;
                    navLock = false;
                }, transitionDuration * 1000 + 30);
            }

            // Highlight dot nav
            for (let i=0; i<dotLinks.length; i++) {
                dotLinks[i].toggleClass('active', i == destination.slideIndex);
            }
        };

        let moveRight = () => {
            autoAdvance = false;
            this.gotoSlide({
                slideIndex: (curIndex + 1) % slides.length,
                direction: 'forwards'
            });
        };

        let moveLeft = () => {
            autoAdvance = false;
            this.gotoSlide({
                slideIndex: (curIndex + slides.length - 1) % slides.length,
                direction: 'backwards'
            });
        };

        let videoScaleOnResize = () => {

            if (!videos.length) {
                return;
            }

            var vWidth = slideHolder.width();
            var vHeight = slideHolder.height();
    
            for (const video of videos) {
                if (vWidth < video.dimensions[0] || vHeight < video.dimensions[1]) {
                    if ( vWidth / vHeight > video.dimensions[0]/video.dimensions[1]) {
                        video.el.css({
                            width: '100%',
                            height: 'auto'
                        });
                    }
                    else {
                        video.el.css({
                            width: 'auto',
                            height: '100%'
                        });
                    }
                }
                else {
                    video.el.css({
                        width: 'auto',
                        height: 'auto'
                    });
                }
            } 
        };

        let videoScaler = () => {
            window.addEventListener('resize', debounce(videoScaleOnResize, 50), false);
            $(()=>{videoScaleOnResize();});
        };

        let autoPlay = () => {
            if (slides.length > 1) {
                setTimeout(()=>{
                    if (autoAdvance) {
                        this.gotoSlide({
                            slideIndex: (curIndex + 1) % slides.length,
                            direction: 'forwards'
                        });
                        autoPlay();
                    }
                }, autoAdvanceDelay * 1000);
            }
        };
        
        addNavs();
        placeCaptions();
        preload();
        autoPlay();
        videoScaler();

        this.gotoSlide({
            slideIndex: 0,
            force: true
        });
    };

    $.fn.carouselFJ = function(){
        this.each((i, el)=>{
            new CarouselFJ($(el));
        })
    };

    $('.fj-carousel').carouselFJ();

})(jQuery, window);
